/** @jsx jsx */
import { Grid, jsx } from 'theme-ui';
import { Fragment, useState } from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Layout from '../components/layout'
import { IoIosCart } from 'react-icons/io'
import { useCart } from '../context/cart-context' 
import horizontal from '../../static/assets/wsb_horizontal_logo.png'
import { Thumbnail } from '../components/thumbnail';

const ProductPage = ({ data }) => {
  const { checkout, addItemToCart } = useCart();
  const product = data.shopifyProduct;
  const hasVariants = product.variants.length > 1;

  const price = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: product.priceRangeV2.minVariantPrice.currencyCode,
  }).format(product.priceRangeV2.minVariantPrice.amount);

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.target);

    addItemToCart({
      variantId: data.get('variantId'),
      quantity: data.get('quantity'),
    });
  };

  const gallery = 
    product.images.length > 1 ? (
      <Grid gap={2} columns={4}>
        {product.images.map((img, index) => (
          <Thumbnail 
            image={img}
            key={img.id}
            alt={product.title}
            index={index}
            onClick={() => changeImage(index)}
          />
        ))}
      </Grid>
    ) : null;

    const sale = 
      product.variants[0].compareAtPrice > product.variants[0].price ? (
        <div>
          <p sx={{ mb: 2, }}>{price}</p>
          <p sx={{ fontSize: '12px'}}>Normally: ${product.variants[0].compareAtPrice}</p>
        </div>
      ) : <p sx={{ mb: 2, }}>{price}</p>

  console.log({ checkout });

  const [currentIndex, setCurrentIndex] = useState(0)

  let changeImage = function(index) {
    setCurrentIndex(index)
  }

  return (
    <Layout>
      <img 
        src={horizontal} 
        alt='Wheat Stalk Boutique' 
        sx={{
          width: '50%',
          display: 'block', 
          margin: 'auto'
        }}
      />

      <div
        sx={{
          bg: 'white',
          borderRadius: 8,
          display: 'grid',
          gap: 4,
          gridTemplateColumns: '1fr 35%',
          margin: '50px auto',
          maxWidth: 1000,
          p: 2,
          pl: 3,
          width: '90%',
          '@media screen and (max-width: 1061px)' : {
            display: 'block',
          }
        }}
      >
        <div sx={{ position: 'relative', }}>
          <h1>{product.title}</h1>
          {sale}
          {/* <p sx={{ mb: 2, }}>{price}</p>
          <p>${product.variants[0].compareAtPrice}</p> */}
          <p>{product.description}</p>

          <form
            onSubmit={handleSubmit}
            sx={{
              display: 'grid',
              gap: 2,
              gridTemplateColumns: hasVariants ? '1fr 1fr 1fr' : '1fr 2fr',
              position: 'absolute',
              bottom: 0,
              width: '100%',
              '@media screen and (max-width: 1061px)' : {
                display: 'block',
                position: 'relative',
                mb: 2,
              }
            }}
          >

            {hasVariants ? (
              <Fragment>
                <div>
                <label htmlFor="variantId" sx={{ display: 'block', mb: 1,}}>
                  Variant
                </label>
                <select
                  name="variantId"
                  id="variantId"
                  sx={{
                    bg: 'white',
                    border: '2px solid',
                    borderColor: 'grayLight',
                    borderRadius: 6,
                    fontSize: 2,
                    p: 2,
                  }}
                >
                  {product.variants
                    .filter((v) => v.availableForSale)
                    .map(({ shopifyId, title }) => (
                      <option key={shopifyId} value={shopifyId}>
                        {title}
                      </option>
                    ))}
                </select>
                </div>
              </Fragment>
            ) : (
              <input
                type="hidden"
                name="variantId"
                value={product.variants[0].shopifyId}
              />
            )}

            <div>
              <label htmlFor="quantity" className="sr-only" sx={{ display: 'block', mb: 1,}}>
                Quantity
              </label>
              <input
                name="quantity"
                id="quantity"
                type="number"
                min={1}
                defaultValue={1}
                sx={{
                  border: '2px solid',
                  borderColor: 'grayLight',
                  borderRadius: 6,
                  fontSize: 2,
                  p: 2,
                }}
            />
            </div>

            <div sx={{mt: '1.7rem'}}>
              <button
                name="button"
                type="submit"
                sx={{
                  bg: 'teal',
                  border: '2px solid',
                  borderColor: 'teal',
                  borderRadius: 6,
                  color: 'white',
                  p: 2,
                  fontSize: 2,
                  fontWeight: 600,
                  width: '100%',
                }}
              >
                <IoIosCart sx={{ mr: 1 }} />
                Add to Cart
              </button>
            </div>

          </form>
        </div>
        <div>
          <GatsbyImage
            image={product.images[currentIndex].gatsbyImageData}
             alt={product.title}
          />          
          <div>
            {gallery}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($productID: String!) {
    shopifyProduct(id: { eq: $productID }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        availableForSale
        shopifyId
        compareAtPrice
        selectedOptions {
          name
          value
        }
        image {
          gatsbyImageData(width: 900, layout: CONSTRAINED)
          id
        }
      }
      priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images {
        originalSrc
        id
        gatsbyImageData(width: 900, layout: CONSTRAINED)
      }
    }
  }
`

export default ProductPage
